import { useEffect } from 'react';

// SEO: per-page browser tab titles while navigating the SPA. The meta server
// already serves the right <title> to crawlers and link previews; this keeps
// the tab in sync as users move around without a reload.

const BASE_TITLE = 'TheDogeList';

export const usePageTitle = (title?: string | null) => {
  useEffect(() => {
    if (title) document.title = `${title} | ${BASE_TITLE}`;
  }, [title]);
};

export default usePageTitle;
